import { css } from 'styled-components'

export const inputs = (themeColors) => ({
  inputs: {
    primary: css`
      color: ${themeColors.secondary};
      background-color: ${themeColors.backgroundPrimary};
      border-color: ${themeColors.backgroundPrimary};
      &::placeholder {
        color: ${themeColors.tertiary};
      }
    `,
  },
})
